import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import {Box} from '@primer/react'

export function VerifyAttestation({url}: {url: string}) {
  return (
    <Box className="d-flex mb-2" sx={{height: '32px'}}>
      <label htmlFor="verify-attestation-with-gh" className="sr-only">
        verify-attestation-with-gh
      </label>
      <input
        id="verify-attestation-with-gh"
        type="text"
        className="form-control input-monospace input-sm color-bg-subtle"
        data-autoselect
        value={url}
        readOnly
        style={{flexGrow: 1}}
      />
      <CopyToClipboardButton
        className="ml-1 mr-0"
        sx={{width: '32px'}}
        textToCopy={url}
        ariaLabel="Verify attestation"
        tooltipProps={{direction: 'nw'}}
      />
    </Box>
  )
}

try{ VerifyAttestation.displayName ||= 'VerifyAttestation' } catch {}